const Announcements = () => {
    return (
      <div className="p-6 bg-white rounded-lg shadow-md min-h-[80vh]">
        <h2 className="text-2xl font-bold mb-4 text-blue-600">Announcements</h2>
        <p>Post and view company-wide or team-specific announcements.</p>
        <ul className="mt-4 list-disc list-inside text-gray-700 space-y-1">
          <li>Team meeting every Friday at 10 AM</li>
          <li>Project deadlines updated for Q4</li>
          <li>New HR policies effective from next month</li>
        </ul>
      </div>
    );
  };
  
  export default Announcements;
  